export const CommingSoonSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="120"
    height="121"
    viewBox="0 0 120 121"
    fill="none"
  >
    <path
      opacity="0.4"
      d="M105 35.5V85.5C105 100.5 97.5 110.5 80 110.5H45C51.05 105.95 55 98.65 55 90.5C55 76.7 43.8 65.5 30 65.5C24.35 65.5 19.15 67.35 15 70.5V35.5C15 20.5 22.5 10.5 40 10.5H80C97.5 10.5 105 20.5 105 35.5Z"
      fill="#73B0F7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M72.5005 19.25C74.5716 19.25 76.2505 20.9289 76.2505 23V33C76.2505 36.4289 79.0716 39.25 82.5005 39.25H92.5005C94.5716 39.25 96.2505 40.9289 96.2505 43C96.2505 45.0711 94.5716 46.75 92.5005 46.75H82.5005C74.9294 46.75 68.7505 40.5711 68.7505 33V23C68.7505 20.9289 70.4294 19.25 72.5005 19.25Z"
      fill="#73B0F7"
    />
    <path
      d="M30.0005 65.5C16.2005 65.5 5.00049 76.7 5.00049 90.5C5.00049 104.3 16.2005 115.5 30.0005 115.5C43.8005 115.5 55.0005 104.3 55.0005 90.5C55.0005 76.7 43.8005 65.5 30.0005 65.5ZM25.8005 96.8501C27.0505 98.1001 27.0505 100.15 25.8005 101.45C25.1505 102.1 24.3505 102.4 23.5005 102.4C22.6505 102.4 21.8504 102.1 21.2004 101.45L12.5505 92.8001C11.3005 91.5501 11.3005 89.4999 12.5505 88.1999L21.2004 79.55C22.4504 78.3 24.5005 78.3 25.8005 79.55C27.0505 80.8 27.0505 82.8499 25.8005 84.1499L19.4506 90.5L25.8005 96.8501ZM47.4005 92.8001L38.7505 101.45C38.1005 102.1 37.3005 102.4 36.4505 102.4C35.6005 102.4 34.8004 102.1 34.1504 101.45C32.9004 100.2 32.9004 98.1501 34.1504 96.8501L40.5005 90.5L34.1504 84.1499C32.9004 82.8999 32.9004 80.85 34.1504 79.55C35.4004 78.3 37.4505 78.3 38.7505 79.55L47.4005 88.1999C48.6505 89.4999 48.6505 91.5001 47.4005 92.8001Z"
      fill="#73B0F7"
    />
  </svg>
);

export const DashboardSvg = () => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.4583 7.91671H15.0416C16.6249 7.91671 17.4166 7.12504 17.4166 5.54171V3.95837C17.4166 2.37504 16.6249 1.58337 15.0416 1.58337H13.4583C11.8749 1.58337 11.0833 2.37504 11.0833 3.95837V5.54171C11.0833 7.12504 11.8749 7.91671 13.4583 7.91671Z"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.95825 17.4167H5.54159C7.12492 17.4167 7.91659 16.625 7.91659 15.0417V13.4584C7.91659 11.875 7.12492 11.0834 5.54159 11.0834H3.95825C2.37492 11.0834 1.58325 11.875 1.58325 13.4584V15.0417C1.58325 16.625 2.37492 17.4167 3.95825 17.4167Z"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.74992 7.91671C6.49882 7.91671 7.91659 6.49894 7.91659 4.75004C7.91659 3.00114 6.49882 1.58337 4.74992 1.58337C3.00102 1.58337 1.58325 3.00114 1.58325 4.75004C1.58325 6.49894 3.00102 7.91671 4.74992 7.91671Z"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.2499 17.4167C15.9988 17.4167 17.4166 15.9989 17.4166 14.25C17.4166 12.5011 15.9988 11.0834 14.2499 11.0834C12.501 11.0834 11.0833 12.5011 11.0833 14.25C11.0833 15.9989 12.501 17.4167 14.2499 17.4167Z"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ManagementSvg = () => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.67094 13.4584H14.3214C15.8255 13.4584 16.6172 12.6667 16.6172 11.1625V1.58337H2.36719V11.1625C2.3751 12.6667 3.16677 13.4584 4.67094 13.4584Z"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.58325 1.58337H17.4166"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.33325 17.4167L9.49992 15.8334V13.4584"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.6667 17.4167L9.5 15.8334"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.9375 8.70837L8.43125 6.62629C8.62916 6.46004 8.89041 6.50754 9.025 6.72921L9.975 8.31254C10.1096 8.53421 10.3708 8.57379 10.5688 8.41546L13.0625 6.33337"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ParcelsSvg = () => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.50952 5.89001L9.49994 9.93543L16.4429 5.91376"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.5 17.1079V9.92749"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.86126 1.96339L3.63376 4.30673C2.67584 4.83714 1.89209 6.16714 1.89209 7.25964V11.7326C1.89209 12.8251 2.67584 14.1551 3.63376 14.6855L7.86126 17.0367C8.76376 17.5355 10.2442 17.5355 11.1467 17.0367L15.3742 14.6855C16.3321 14.1551 17.1158 12.8251 17.1158 11.7326V7.25964C17.1158 6.16714 16.3321 4.83714 15.3742 4.30673L11.1467 1.95548C10.2363 1.45673 8.76376 1.45673 7.86126 1.96339Z"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WarehouseSvg = () => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.58325 7.12504V5.54171C1.58325 3.16671 3.16659 1.58337 5.54159 1.58337H13.4583C15.8333 1.58337 17.4166 3.16671 17.4166 5.54171V7.12504"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.58325 11.875V13.4583C1.58325 15.8333 3.16659 17.4167 5.54159 17.4167H13.4583C15.8333 17.4167 17.4166 15.8333 17.4166 13.4583V11.875"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.3042 7.33081L9.50003 9.76123L13.6642 7.34666"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.5 14.0679V9.7533"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.51827 4.97961L5.98494 6.3888C5.41494 6.70547 4.93994 7.50504 4.93994 8.16212V10.8459C4.93994 11.503 5.40702 12.3025 5.98494 12.6192L8.51827 14.0284C9.0566 14.3292 9.94327 14.3292 10.4895 14.0284L13.0229 12.6192C13.5929 12.3025 14.0679 11.503 14.0679 10.8459V8.16212C14.0679 7.50504 13.6008 6.70547 13.0229 6.3888L10.4895 4.97961C9.94327 4.67086 9.0566 4.67086 8.51827 4.97961Z"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RevenuesSvg = () => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5033 9.49998C16.5617 9.49998 17.4167 8.70831 16.6567 6.11165C16.1421 4.36206 14.6379 2.8579 12.8883 2.34331C10.2917 1.58331 9.5 2.43831 9.5 4.49665V6.77665C9.5 8.70831 10.2917 9.49998 11.875 9.49998H14.5033Z"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.8334 11.6375C15.0971 15.3029 11.5821 17.9629 7.58421 17.3137C4.5838 16.8308 2.16921 14.4162 1.67838 11.4158C1.03713 7.43373 3.6813 3.91873 7.33088 3.17456"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MessageSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M14.6668 6.66659V8.66659C14.6668 11.3333 13.3335 12.6666 10.6668 12.6666H10.3335C10.1268 12.6666 9.92683 12.7666 9.80016 12.9333L8.80016 14.2666C8.36016 14.8533 7.64016 14.8533 7.20016 14.2666L6.20016 12.9333C6.0935 12.7866 5.84683 12.6666 5.66683 12.6666H5.3335C2.66683 12.6666 1.3335 11.9999 1.3335 8.66659V5.33325C1.3335 2.66659 2.66683 1.33325 5.3335 1.33325H9.3335"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.0002 4.66658C13.9206 4.66658 14.6668 3.92039 14.6668 2.99992C14.6668 2.07944 13.9206 1.33325 13.0002 1.33325C12.0797 1.33325 11.3335 2.07944 11.3335 2.99992C11.3335 3.92039 12.0797 4.66658 13.0002 4.66658Z"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6644 7.33333H10.6704"
      stroke="#475B78"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99715 7.33333H8.00314"
      stroke="#475B78"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.32967 7.33333H5.33566"
      stroke="#475B78"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EmailSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M14.6666 6.99992V10.3333C14.6666 12.6666 13.3333 13.6666 11.3333 13.6666H4.66659C2.66659 13.6666 1.33325 12.6666 1.33325 10.3333V5.66659C1.33325 3.33325 2.66659 2.33325 4.66659 2.33325H9.33325"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.6665 6L6.75317 7.66667C7.43984 8.21333 8.56651 8.21333 9.25317 7.66667L10.0398 7.04"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.9999 5.33333C13.9204 5.33333 14.6666 4.58714 14.6666 3.66667C14.6666 2.74619 13.9204 2 12.9999 2C12.0794 2 11.3333 2.74619 11.3333 3.66667C11.3333 4.58714 12.0794 5.33333 12.9999 5.33333Z"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EditSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M10.6668 1.33325H5.3335C2.66683 1.33325 1.3335 2.66659 1.3335 5.33325V13.9999C1.3335 14.3666 1.6335 14.6666 2.00016 14.6666H10.6668C13.3335 14.6666 14.6668 13.3333 14.6668 10.6666V5.33325C14.6668 2.66659 13.3335 1.33325 10.6668 1.33325Z"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.60685 5.22665L5.14685 8.68665C5.01352 8.81998 4.88686 9.07998 4.86019 9.26665L4.67353 10.5866C4.60686 11.0666 4.94019 11.4 5.42019 11.3333L6.74018 11.1466C6.92684 11.12 7.18686 10.9933 7.32019 10.86L10.7802 7.39998C11.3735 6.80665 11.6602 6.11331 10.7802 5.23331C9.90019 4.34664 9.20685 4.62665 8.60685 5.22665Z"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.11353 5.71997C8.40686 6.76664 9.22686 7.5933 10.2802 7.88664"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DeleteSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M14 3.98665C11.78 3.76665 9.54667 3.65332 7.32 3.65332C6 3.65332 4.68 3.71999 3.36 3.85332L2 3.98665"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.66675 3.31337L5.81341 2.44004C5.92008 1.80671 6.00008 1.33337 7.12675 1.33337H8.87341C10.0001 1.33337 10.0867 1.83337 10.1867 2.44671L10.3334 3.31337"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5667 6.09338L12.1334 12.8067C12.06 13.8534 12 14.6667 10.14 14.6667H5.86002C4.00002 14.6667 3.94002 13.8534 3.86668 12.8067L3.43335 6.09338"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.88672 11H9.10672"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.33325 8.33337H9.66659"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AwaitingConSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
  >
    <path
      d="M5.625 11.125V7.375L4.375 8.625"
      stroke="#475B78"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.625 7.375L6.875 8.625"
      stroke="#475B78"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.75 6.75V9.875C13.75 13 12.5 14.25 9.375 14.25H5.625C2.5 14.25 1.25 13 1.25 9.875V6.125C1.25 3 2.5 1.75 5.625 1.75H8.75"
      stroke="#475B78"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.75 6.75H11.25C9.375 6.75 8.75 6.125 8.75 4.25V1.75L13.75 6.75Z"
      stroke="#475B78"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const HideSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M9.58126 6.4187L6.41876 9.5812C6.01251 9.17495 5.76251 8.6187 5.76251 7.99995C5.76251 6.76245 6.76251 5.76245 8.00001 5.76245C8.61876 5.76245 9.17501 6.01245 9.58126 6.4187Z"
      stroke="#475B78"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6375 4.1063C10.5438 3.2813 9.29377 2.8313 8.00002 2.8313C5.79377 2.8313 3.73752 4.1313 2.30627 6.3813C1.74377 7.26255 1.74377 8.7438 2.30627 9.62505C2.80002 10.4 3.37502 11.0688 4.00002 11.6063"
      stroke="#475B78"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.76251 12.7063C6.47501 13.0063 7.23126 13.1688 8.00001 13.1688C10.2063 13.1688 12.2625 11.8688 13.6938 9.6188C14.2563 8.73755 14.2563 7.2563 13.6938 6.37505C13.4875 6.05005 13.2625 5.7438 13.0313 5.4563"
      stroke="#475B78"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.1938 8.4375C10.0313 9.31875 9.31252 10.0375 8.43127 10.2"
      stroke="#475B78"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.41875 9.5813L1.75 14.25"
      stroke="#475B78"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.25 1.75L9.58124 6.41875"
      stroke="#475B78"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FilterSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M3.875 1.8125H12.125C12.8125 1.8125 13.375 2.375 13.375 3.0625V4.4375C13.375 4.9375 13.0625 5.5625 12.75 5.875L10.0625 8.25C9.6875 8.5625 9.4375 9.1875 9.4375 9.6875V12.375C9.4375 12.75 9.1875 13.25 8.875 13.4375L8 14C7.1875 14.5 6.0625 13.9375 6.0625 12.9375V9.625C6.0625 9.1875 5.8125 8.625 5.5625 8.3125L3.1875 5.8125C2.875 5.5 2.625 4.9375 2.625 4.5625V3.125C2.625 2.375 3.1875 1.8125 3.875 1.8125Z"
      stroke="#475B78"
      strokeWidth="1.1"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.33125 1.8125L4.25 6.75"
      stroke="#475B78"
      strokeWidth="1.1"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SortSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
  >
    <path
      d="M5.63127 13.3125L2.49377 10.1813"
      stroke="#475B78"
      strokeWidth="1.1"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.63123 2.6875V13.3125"
      stroke="#475B78"
      strokeWidth="1.1"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.36877 2.6875L12.5063 5.81875"
      stroke="#475B78"
      strokeWidth="1.1"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.36877 13.3125V2.6875"
      stroke="#475B78"
      strokeWidth="1.1"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowDownSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M3.10337 5.84495L4.97587 7.71744L6.11921 8.86661C6.60337 9.35078 7.39087 9.35078 7.87504 8.86661L10.8967 5.84495C11.2934 5.44828 11.0075 4.77161 10.4534 4.77161L7.18087 4.77161H3.54671C2.98671 4.77161 2.70671 5.44828 3.10337 5.84495Z"
      fill="#B5BDC9"
    />
  </svg>
);

export const AttachSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M8.22012 8.09995L6.57345 9.74661C5.66012 10.6599 5.66012 12.1333 6.57345 13.0466C7.48678 13.9599 8.96012 13.9599 9.87345 13.0466L12.4668 10.4533C14.2868 8.63328 14.2868 5.67328 12.4668 3.85328C10.6468 2.03328 7.68678 2.03328 5.86678 3.85328L3.04012 6.67995C1.48012 8.23995 1.48012 10.7733 3.04012 12.3399"
      stroke="#475B78"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DoneSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M8.00004 14.6667C11.6667 14.6667 14.6667 11.6667 14.6667 8.00004C14.6667 4.33337 11.6667 1.33337 8.00004 1.33337C4.33337 1.33337 1.33337 4.33337 1.33337 8.00004C1.33337 11.6667 4.33337 14.6667 8.00004 14.6667Z"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.16663 7.99995L7.05329 9.88661L10.8333 6.11328"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DocumentSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M14 4.66671V11.3334C14 13.3334 13 14.6667 10.6667 14.6667H5.33333C3 14.6667 2 13.3334 2 11.3334V4.66671C2 2.66671 3 1.33337 5.33333 1.33337H10.6667C13 1.33337 14 2.66671 14 4.66671Z"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.66663 3V4.33333C9.66663 5.06667 10.2666 5.66667 11 5.66667H12.3333"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33337 8.66663H8.00004"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33337 11.3334H10.6667"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const VectorSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M4.66671 5.33337H2.66671C1.93337 5.33337 1.33337 4.73337 1.33337 4.00004V2.66671C1.33337 1.93337 1.93337 1.33337 2.66671 1.33337H4.66671C5.40004 1.33337 6.00004 1.93337 6.00004 2.66671V4.00004C6.00004 4.73337 5.40004 5.33337 4.66671 5.33337Z"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.8666 4.66667H11.4666C11.0266 4.66667 10.6666 4.30666 10.6666 3.86666V2.80001C10.6666 2.36001 11.0266 2 11.4666 2H13.8666C14.3066 2 14.6666 2.36001 14.6666 2.80001V3.86666C14.6666 4.30666 14.3066 4.66667 13.8666 4.66667Z"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.8666 9.66667H11.4666C11.0266 9.66667 10.6666 9.30666 10.6666 8.86666V7.80001C10.6666 7.36001 11.0266 7 11.4666 7H13.8666C14.3066 7 14.6666 7.36001 14.6666 7.80001V8.86666C14.6666 9.30666 14.3066 9.66667 13.8666 9.66667Z"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 3.33337H10.6667"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33337 3.33337V12C8.33337 12.7334 8.93337 13.3334 9.66671 13.3334H10.6667"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33337 8.33337H10.6667"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.8666 14.6667H11.4666C11.0266 14.6667 10.6666 14.3067 10.6666 13.8667V12.8C10.6666 12.36 11.0266 12 11.4666 12H13.8666C14.3066 12 14.6666 12.36 14.6666 12.8V13.8667C14.6666 14.3067 14.3066 14.6667 13.8666 14.6667Z"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MoreSvg = () => (
  <svg
    width="4"
    height="10"
    viewBox="0 0 4 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="3.06665"
      y="0.733276"
      width="2.13333"
      height="2.13333"
      rx="1.06667"
      transform="rotate(90 3.06665 0.733276)"
      fill="#475B78"
    />
    <rect
      x="3.06665"
      y="3.93323"
      width="2.13333"
      height="2.13333"
      rx="1.06667"
      transform="rotate(90 3.06665 3.93323)"
      fill="#475B78"
    />
    <rect
      x="3.06665"
      y="7.1333"
      width="2.13333"
      height="2.13333"
      rx="1.06667"
      transform="rotate(90 3.06665 7.1333)"
      fill="#475B78"
    />
  </svg>
);

export const ResetSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
  >
    <path
      d="M10.3 14.4467C13.16 13.6934 15.2666 11.0934 15.2666 8.00004C15.2666 4.32004 12.3066 1.33337 8.59995 1.33337C4.15329 1.33337 1.93329 5.04004 1.93329 5.04004M1.93329 5.04004V2.00004M1.93329 5.04004H3.27329H4.89329"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.93329 8C1.93329 11.68 4.91996 14.6667 8.59995 14.6667"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2 2"
    />
  </svg>
);

export const EditSvg2 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
  >
    <path
      d="M8.1333 1.33337H6.79997C3.46663 1.33337 2.1333 2.66671 2.1333 6.00004V10C2.1333 13.3334 3.46663 14.6667 6.79997 14.6667H10.8C14.1333 14.6667 15.4666 13.3334 15.4666 10V8.66671"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.4933 2.01338L6.23997 7.26671C6.03997 7.46671 5.83997 7.86005 5.79997 8.14671L5.5133 10.1534C5.40663 10.88 5.91997 11.3867 6.64663 11.2867L8.6533 11C8.9333 10.96 9.32663 10.76 9.5333 10.56L14.7866 5.30671C15.6933 4.40005 16.12 3.34671 14.7866 2.01338C13.4533 0.680046 12.4 1.10671 11.4933 2.01338Z"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.74 2.76672C11.1867 4.36006 12.4333 5.60672 14.0333 6.06006"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BackSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
  >
    <path
      d="M6.87992 4.45337L2.83325 8.50004L6.87992 12.5467"
      stroke="#475B78"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1668 8.5H2.94678"
      stroke="#475B78"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MenuSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M2.25 5.25H15.75"
      stroke="#526581"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M2.25 9H15.75"
      stroke="#526581"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M2.25 12.75H15.75"
      stroke="#526581"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const LogoutSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M9.99992 2.5C10.4602 2.5 10.8333 2.8731 10.8333 3.33333C10.8333 3.76069 10.5116 4.11292 10.0971 4.16106L9.99992 4.16667H5.83325C5.40589 4.16667 5.05366 4.48837 5.00552 4.90282L4.99992 5V15C4.99992 15.4274 5.32162 15.7796 5.73607 15.8277L5.83325 15.8333H9.58325C10.0435 15.8333 10.4166 16.2064 10.4166 16.6667C10.4166 17.094 10.0949 17.4463 9.68044 17.4944L9.58325 17.5H5.83325C4.50185 17.5 3.41353 16.4593 3.3375 15.1469L3.33325 15V5C3.33325 3.6686 4.37402 2.58028 5.68636 2.50424L5.83325 2.5H9.99992ZM14.7558 7.05372L17.1128 9.41075C17.4383 9.73617 17.4383 10.2638 17.1128 10.5892L14.7558 12.9462C14.4303 13.2717 13.9028 13.2717 13.5773 12.9462C13.2518 12.6208 13.2518 12.0932 13.5773 11.7677L14.5118 10.8333H9.99992C9.53967 10.8333 9.16658 10.4602 9.16658 10C9.16658 9.53975 9.53967 9.16667 9.99992 9.16667H14.5118L13.5773 8.23223C13.2518 7.9068 13.2518 7.37916 13.5773 7.05372C13.9028 6.72828 14.4303 6.72828 14.7558 7.05372Z"
      fill="#09244b"
    />
  </svg>
);

export const PlusSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M1.5 12H22.5"
      stroke="white"
      strokeWidth="1.71429"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 22.5L12 1.5"
      stroke="white"
      strokeWidth="1.71429"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CloseSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
  >
    <path
      d="M5 14L14 5"
      stroke="#475B78"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 14L5 5"
      stroke="#475B78"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SearchSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="vuesax/linear/search-normal">
      <g id="search-normal">
        <path
          id="Vector"
          d="M7.66659 14C11.1644 14 13.9999 11.1645 13.9999 7.66671C13.9999 4.1689 11.1644 1.33337 7.66659 1.33337C4.16878 1.33337 1.33325 4.1689 1.33325 7.66671C1.33325 11.1645 4.16878 14 7.66659 14Z"
          stroke="#475B78"
          strokeWidth="0.875"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M14.6666 14.6667L13.3333 13.3334"
          stroke="#475B78"
          strokeWidth="0.875"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
  </svg>
);

export const CheckedSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="7"
    viewBox="0 0 11 7"
    fill="none"
  >
    <path
      d="M1.427 3.50005L4.13909 6.21213L9.57284 0.787964"
      stroke="#475B78"
      strokeWidth="1.4375"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UploadFileSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M8.85529 4.27348L4.13149 9.07667C3.9751 9.24927 3.89107 9.4754 3.89681 9.70824C3.90254 9.94108 3.99759 10.1628 4.16228 10.3275C4.32698 10.4922 4.54869 10.5872 4.78153 10.593C5.01437 10.5987 5.2405 10.5147 5.4131 10.3583L11.0442 4.64775C11.357 4.30256 11.5251 3.8503 11.5136 3.38463C11.5021 2.91895 11.312 2.47551 10.9826 2.14613C10.6533 1.81674 10.2098 1.62664 9.74414 1.61517C9.27847 1.60371 8.82621 1.77176 8.48102 2.08454L2.84988 7.79507C2.34002 8.30492 2.05359 8.99643 2.05359 9.71748C2.05359 10.4385 2.34002 11.13 2.84988 11.6399C3.35973 12.1497 4.05125 12.4362 4.77229 12.4362C5.49334 12.4362 6.18485 12.1497 6.6947 11.6399L11.3505 6.99548"
      stroke="#475B78"
      strokeWidth="0.761905"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ExportFileSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M8.00004 1.33337C4.32004 1.33337 1.33337 4.32004 1.33337 8.00004C1.33337 11.68 4.32004 14.6667 8.00004 14.6667C11.68 14.6667 14.6667 11.68 14.6667 8.00004"
      stroke="#09244B"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.66663 7.33337L14.1333 1.8667"
      stroke="#09244B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6667 4.55337V1.33337H11.4467"
      stroke="#09244B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DocumentCopySvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M11.3334 8.93329V10.9333C11.3334 13.6 10.2667 14.6666 7.60004 14.6666H5.06671C2.40004 14.6666 1.33337 13.6 1.33337 10.9333V8.39996C1.33337 5.73329 2.40004 4.66663 5.06671 4.66663H7.06671"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.3333 8.93329H9.19998C7.59998 8.93329 7.06665 8.39996 7.06665 6.79996V4.66663L11.3333 8.93329Z"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.73328 1.33337H10.3999"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66663 3.33337C4.66663 2.22671 5.55996 1.33337 6.66663 1.33337H8.41329"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6667 5.33337V9.46004C14.6667 10.4934 13.8267 11.3334 12.7933 11.3334"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6666 5.33337H12.6666C11.1666 5.33337 10.6666 4.83337 10.6666 3.33337V1.33337L14.6666 5.33337Z"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SmsTracking = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M1.33337 5.66671C1.33337 3.33337 2.66671 2.33337 4.66671 2.33337H11.3334C13.3334 2.33337 14.6667 3.33337 14.6667 5.66671V10.3334C14.6667 12.6667 13.3334 13.6667 11.3334 13.6667H4.66671"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.3334 6L9.24674 7.66667C8.56008 8.21333 7.43341 8.21333 6.74674 7.66667L4.66675 6"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.33337 11H5.33337"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.33337 8.33337H3.33337"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AddEmployeeSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M7.64018 9.15291C8.67479 9.15291 9.51351 8.31419 9.51351 7.27958C9.51351 6.24497 8.67479 5.40625 7.64018 5.40625C6.60556 5.40625 5.76685 6.24497 5.76685 7.27958C5.76685 8.31419 6.60556 9.15291 7.64018 9.15291Z"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.1002 13.4663C11.1002 11.9129 9.55351 10.6462 7.64017 10.6462C5.72684 10.6462 4.18018 11.9063 4.18018 13.4663"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 8.33333C14 11.8333 11.1667 14.6667 7.66671 14.6667C4.16671 14.6667 1.33337 11.8333 1.33337 8.33333C1.33337 4.83333 4.16671 2 7.66671 2C8.54004 2 9.37337 2.17333 10.1334 2.49333C10.0467 2.75999 10 3.04 10 3.33333C10 3.83333 10.14 4.30667 10.3867 4.70667C10.52 4.93333 10.6934 5.13998 10.8934 5.31331C11.36 5.73998 11.98 6 12.6667 6C12.96 6 13.24 5.95332 13.5 5.85999C13.82 6.61999 14 7.46 14 8.33333Z"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.3333 3.33366C15.3333 3.54699 15.3067 3.75365 15.2533 3.95365C15.1933 4.22032 15.0867 4.48032 14.9467 4.70699C14.6267 5.24699 14.1133 5.66698 13.5 5.86031C13.24 5.95364 12.96 6.00033 12.6667 6.00033C11.98 6.00033 11.36 5.74031 10.8933 5.31364C10.6933 5.14031 10.52 4.93366 10.3867 4.70699C10.14 4.30699 10 3.83366 10 3.33366C10 3.04033 10.0467 2.76032 10.1333 2.49365C10.26 2.10699 10.4733 1.76034 10.7533 1.47367C11.24 0.973674 11.92 0.666992 12.6667 0.666992C13.4533 0.666992 14.1667 1.007 14.6467 1.55367C15.0733 2.027 15.3333 2.65366 15.3333 3.33366Z"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.66 3.32031H11.6733"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.6666 2.34668V4.34001"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const HidePasswordSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M21.27 9.18005C20.98 8.72005 20.67 8.29005 20.35 7.89005C19.98 7.42005 19.28 7.38005 18.86 7.80005L15.86 10.8001C16.08 11.4601 16.12 12.2201 15.92 13.0101C15.57 14.4201 14.43 15.5601 13.02 15.9101C12.23 16.1101 11.47 16.0701 10.81 15.8501C10.81 15.8501 9.38 17.2801 8.35 18.3101C7.85 18.8101 8.01 19.6901 8.68 19.9501C9.75 20.3601 10.86 20.5701 12 20.5701C13.78 20.5701 15.51 20.0501 17.09 19.0801C18.7 18.0801 20.15 16.6101 21.32 14.74C22.27 13.2301 22.22 10.6901 21.27 9.18005Z"
      fill="#8491A5"
    />
    <path
      d="M14.02 9.98001L9.98 14.02C9.47 13.5 9.14 12.78 9.14 12C9.14 10.43 10.42 9.14001 12 9.14001C12.78 9.14001 13.5 9.47001 14.02 9.98001Z"
      fill="#8491A5"
    />
    <path
      d="M18.25 5.75005L14.86 9.14005C14.13 8.40005 13.12 7.96005 12 7.96005C9.76 7.96005 7.96 9.77005 7.96 12.0001C7.96 13.1201 8.41 14.1301 9.14 14.8601L5.76 18.2501H5.75C4.64 17.3501 3.62 16.2001 2.75 14.8401C1.75 13.2701 1.75 10.7201 2.75 9.15005C3.91 7.33005 5.33 5.90005 6.91 4.92005C8.49 3.96005 10.22 3.43005 12 3.43005C14.23 3.43005 16.39 4.25005 18.25 5.75005Z"
      fill="#8491A5"
    />
    <path
      d="M14.86 12C14.86 13.57 13.58 14.86 12 14.86C11.94 14.86 11.89 14.86 11.83 14.84L14.84 11.83C14.86 11.89 14.86 11.94 14.86 12Z"
      fill="#8491A5"
    />
    <path
      d="M21.77 2.23C21.47 1.93 20.98 1.93 20.68 2.23L2.23 20.69C1.93 20.99 1.93 21.48 2.23 21.78C2.38 21.92 2.57 22 2.77 22C2.97 22 3.16 21.92 3.31 21.77L21.77 3.31C22.08 3.01 22.08 2.53 21.77 2.23Z"
      fill="#8491A5"
    />
  </svg>
);

export const ShowPasswordSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M21.25 9.15005C18.94 5.52005 15.56 3.43005 12 3.43005C10.22 3.43005 8.49 3.95005 6.91 4.92005C5.33 5.90005 3.91 7.33005 2.75 9.15005C1.75 10.7201 1.75 13.2701 2.75 14.8401C5.06 18.4801 8.44 20.5601 12 20.5601C13.78 20.5601 15.51 20.0401 17.09 19.0701C18.67 18.0901 20.09 16.6601 21.25 14.8401C22.25 13.2801 22.25 10.7201 21.25 9.15005ZM12 16.0401C9.76 16.0401 7.96 14.2301 7.96 12.0001C7.96 9.77005 9.76 7.96005 12 7.96005C14.24 7.96005 16.04 9.77005 16.04 12.0001C16.04 14.2301 14.24 16.0401 12 16.0401Z"
      fill="#575E73"
    />
    <path
      d="M12 9.14001C10.43 9.14001 9.15002 10.42 9.15002 12C9.15002 13.57 10.43 14.85 12 14.85C13.57 14.85 14.86 13.57 14.86 12C14.86 10.43 13.57 9.14001 12 9.14001Z"
      fill="#575E73"
    />
  </svg>
);

export const CloseModalSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
  >
    <path
      d="M6.31592 18.1842L17.6843 6.81577"
      stroke="#8491A5"
      strokeWidth="1.89474"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.6843 18.1842L6.31592 6.81577"
      stroke="#8491A5"
      strokeWidth="1.89474"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UserSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M7.64042 9.15291C8.67503 9.15291 9.51376 8.31419 9.51376 7.27958C9.51376 6.24497 8.67503 5.40625 7.64042 5.40625C6.60581 5.40625 5.76709 6.24497 5.76709 7.27958C5.76709 8.31419 6.60581 9.15291 7.64042 9.15291Z"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.1002 13.4663C11.1002 11.9129 9.55351 10.6462 7.64017 10.6462C5.72684 10.6462 4.18018 11.9063 4.18018 13.4663"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.0002 8.33333C14.0002 11.8333 11.1668 14.6667 7.66683 14.6667C4.16683 14.6667 1.3335 11.8333 1.3335 8.33333C1.3335 4.83333 4.16683 2 7.66683 2C8.54016 2 9.3735 2.17333 10.1335 2.49333C10.0468 2.75999 10.0002 3.04 10.0002 3.33333C10.0002 3.83333 10.1402 4.30667 10.3868 4.70667C10.5202 4.93333 10.6935 5.13998 10.8935 5.31331C11.3602 5.73998 11.9802 6 12.6668 6C12.9602 6 13.2402 5.95332 13.5002 5.85999C13.8202 6.61999 14.0002 7.46 14.0002 8.33333Z"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.3333 3.33366C15.3333 3.54699 15.3067 3.75365 15.2533 3.95365C15.1933 4.22032 15.0867 4.48032 14.9467 4.70699C14.6267 5.24699 14.1133 5.66698 13.5 5.86031C13.24 5.95364 12.96 6.00033 12.6667 6.00033C11.98 6.00033 11.36 5.74031 10.8933 5.31364C10.6933 5.14031 10.52 4.93366 10.3867 4.70699C10.14 4.30699 10 3.83366 10 3.33366C10 3.04033 10.0467 2.76032 10.1333 2.49365C10.26 2.10699 10.4733 1.76034 10.7533 1.47367C11.24 0.973674 11.92 0.666992 12.6667 0.666992C13.4533 0.666992 14.1667 1.007 14.6467 1.55367C15.0733 2.027 15.3333 2.65366 15.3333 3.33366Z"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.66 3.32031H11.6733"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.6665 2.34668V4.34001"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SortUp = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M6.00658 13.6667L2.65991 10.3267"
      stroke="#2E4566"
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.00659 2.33334V13.6667"
      stroke="#2E4566"
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.99341 2.33334L13.3401 5.67334"
      stroke="#8491A5"
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.99341 13.6667V2.33334"
      stroke="#8491A5"
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SortDown = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M6.00658 13.6667L2.65991 10.3267"
      stroke="#8491A5"
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.00659 2.33334V13.6667"
      stroke="#8491A5"
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.99341 2.33334L13.3401 5.67334"
      stroke="#2E4566"
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.99341 13.6667V2.33334"
      stroke="#2E4566"
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AddFileSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M4.5 9H13.5"
      stroke="#416FF4"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 13.5V4.5"
      stroke="#416FF4"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FaceIDSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10 12.4001C9.24167 12.4001 8.625 11.7835 8.625 11.0251V8.96682C8.625 8.20848 9.24167 7.5918 10 7.5918C10.7583 7.5918 11.375 8.20848 11.375 8.96682V11.0251C11.375 11.7835 10.7583 12.4001 10 12.4001Z"
      stroke="#475B78"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <path
      d="M14.1502 11.2247C13.9835 13.3747 12.1835 15.0581 10.0002 15.0581C7.70016 15.0581 5.8335 13.1914 5.8335 10.8914V9.10807C5.8335 6.80807 7.70016 4.94141 10.0002 4.94141C12.1585 4.94141 13.9335 6.58306 14.1418 8.68306"
      stroke="#475B78"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <path
      d="M12.5 1.6665H14.1667C16.6667 1.6665 18.3333 3.33317 18.3333 5.83317V7.49984"
      stroke="#475B78"
      strokeWidth="1.25"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.6665 7.49984V5.83317C1.6665 3.33317 3.33317 1.6665 5.83317 1.6665H7.49984"
      stroke="#475B78"
      strokeWidth="1.25"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 18.3333H14.1667C16.6667 18.3333 18.3333 16.6667 18.3333 14.1667V12.5"
      stroke="#475B78"
      strokeWidth="1.25"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.6665 12.5V14.1667C1.6665 16.6667 3.33317 18.3333 5.83317 18.3333H7.49984"
      stroke="#475B78"
      strokeWidth="1.25"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UserSvg2 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10.1331 9.05817C10.0498 9.04984 9.9498 9.04984 9.85814 9.05817C7.8748 8.9915 6.2998 7.3665 6.2998 5.3665C6.2998 3.32484 7.9498 1.6665 9.9998 1.6665C12.0415 1.6665 13.6998 3.32484 13.6998 5.3665C13.6915 7.3665 12.1165 8.9915 10.1331 9.05817Z"
      stroke="#475B78"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.9666 12.1335C3.94993 13.4835 3.94993 15.6835 5.9666 17.0252C8.25827 18.5585 12.0166 18.5585 14.3083 17.0252C16.3249 15.6752 16.3249 13.4752 14.3083 12.1335C12.0249 10.6085 8.2666 10.6085 5.9666 12.1335Z"
      stroke="#475B78"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EmailSvg2 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M14.167 17.0832H5.83366C3.33366 17.0832 1.66699 15.8332 1.66699 12.9165V7.08317C1.66699 4.1665 3.33366 2.9165 5.83366 2.9165H14.167C16.667 2.9165 18.3337 4.1665 18.3337 7.08317V12.9165C18.3337 15.8332 16.667 17.0832 14.167 17.0832Z"
      stroke="#475B78"
      strokeWidth="1.25"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1668 7.5L11.5585 9.58333C10.7002 10.2667 9.29183 10.2667 8.43349 9.58333L5.8335 7.5"
      stroke="#475B78"
      strokeWidth="1.25"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WorldSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M9.99984 18.3332C14.6022 18.3332 18.3332 14.6022 18.3332 9.99984C18.3332 5.39746 14.6022 1.6665 9.99984 1.6665C5.39746 1.6665 1.6665 5.39746 1.6665 9.99984C1.6665 14.6022 5.39746 18.3332 9.99984 18.3332Z"
      stroke="#475B78"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66667 2.5H7.5C5.875 7.36667 5.875 12.6333 7.5 17.5H6.66667"
      stroke="#475B78"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 2.5C14.125 7.36667 14.125 12.6333 12.5 17.5"
      stroke="#475B78"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 13.3333V12.5C7.36667 14.125 12.6333 14.125 17.5 12.5V13.3333"
      stroke="#475B78"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 7.5C7.36667 5.875 12.6333 5.875 17.5 7.5"
      stroke="#475B78"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CitySvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M7.49984 18.3332H12.4998C16.6665 18.3332 18.3332 16.6665 18.3332 12.4998V7.49984C18.3332 3.33317 16.6665 1.6665 12.4998 1.6665H7.49984C3.33317 1.6665 1.6665 3.33317 1.6665 7.49984V12.4998C1.6665 16.6665 3.33317 18.3332 7.49984 18.3332Z"
      stroke="#475B78"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 1.6665L11.625 18.3332"
      stroke="#475B78"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.60819 10.1831L1.6665 12.4998"
      stroke="#475B78"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DistrictSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M18.3337 7.50009V12.5001C18.3337 14.5834 17.917 16.0418 16.9837 16.9834L11.667 11.6668L18.1087 5.2251C18.2587 5.88343 18.3337 6.63343 18.3337 7.50009Z"
      stroke="#475B78"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.1087 5.22484L5.22532 18.1082C2.71698 17.5332 1.66699 15.7998 1.66699 12.4998V7.49984C1.66699 3.33317 3.33366 1.6665 7.50033 1.6665H12.5003C15.8003 1.6665 17.5337 2.71651 18.1087 5.22484Z"
      stroke="#475B78"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.9834 16.9832C16.0418 17.9165 14.5834 18.3332 12.5001 18.3332H7.50011C6.63344 18.3332 5.88343 18.2582 5.2251 18.1082L11.6668 11.6665L16.9834 16.9832Z"
      stroke="#475B78"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.20022 6.6501C5.76689 4.20843 9.43356 4.20843 10.0002 6.6501C10.3252 8.08343 9.42522 9.3001 8.63355 10.0501C8.05855 10.6001 7.15023 10.6001 6.5669 10.0501C5.77523 9.3001 4.86689 8.08343 5.20022 6.6501Z"
      stroke="#475B78"
      strokeWidth="1.25"
    />
    <path
      d="M7.57908 7.25016H7.58657"
      stroke="#475B78"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PhoneSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M14.5415 18.9582C13.5998 18.9582 12.6082 18.7332 11.5832 18.2998C10.5832 17.8748 9.57484 17.2915 8.5915 16.5832C7.6165 15.8665 6.67484 15.0665 5.78317 14.1915C4.89984 13.2998 4.09984 12.3582 3.3915 11.3915C2.67484 10.3915 2.09984 9.3915 1.6915 8.42484C1.25817 7.3915 1.0415 6.3915 1.0415 5.44984C1.0415 4.79984 1.15817 4.18317 1.38317 3.60817C1.6165 3.0165 1.9915 2.4665 2.49984 1.9915C3.1415 1.35817 3.87484 1.0415 4.65817 1.0415C4.98317 1.0415 5.3165 1.1165 5.59984 1.24984C5.92484 1.39984 6.19984 1.62484 6.39984 1.92484L8.33317 4.64984C8.50817 4.8915 8.6415 5.12484 8.73317 5.35817C8.8415 5.60817 8.89984 5.85817 8.89984 6.09984C8.89984 6.4165 8.80817 6.72484 8.63317 7.0165C8.50817 7.2415 8.3165 7.48317 8.07484 7.72484L7.50817 8.3165C7.5165 8.3415 7.52484 8.35817 7.53317 8.37484C7.63317 8.54984 7.83317 8.84984 8.2165 9.29984C8.62484 9.7665 9.00817 10.1915 9.3915 10.5832C9.88317 11.0665 10.2915 11.4498 10.6748 11.7665C11.1498 12.1665 11.4582 12.3665 11.6415 12.4582L11.6248 12.4998L12.2332 11.8998C12.4915 11.6415 12.7415 11.4498 12.9832 11.3248C13.4415 11.0415 14.0248 10.9915 14.6082 11.2332C14.8248 11.3248 15.0582 11.4498 15.3082 11.6248L18.0748 13.5915C18.3832 13.7998 18.6082 14.0665 18.7415 14.3832C18.8665 14.6998 18.9248 14.9915 18.9248 15.2832C18.9248 15.6832 18.8332 16.0832 18.6582 16.4582C18.4832 16.8332 18.2665 17.1582 17.9915 17.4582C17.5165 17.9832 16.9998 18.3582 16.3998 18.5998C15.8248 18.8332 15.1998 18.9582 14.5415 18.9582ZM4.65817 2.2915C4.19984 2.2915 3.77484 2.4915 3.3665 2.8915C2.98317 3.24984 2.7165 3.6415 2.54984 4.0665C2.37484 4.49984 2.2915 4.95817 2.2915 5.44984C2.2915 6.22484 2.47484 7.0665 2.8415 7.93317C3.2165 8.8165 3.7415 9.73317 4.40817 10.6498C5.07484 11.5665 5.83317 12.4582 6.6665 13.2998C7.49984 14.1248 8.39984 14.8915 9.32484 15.5665C10.2248 16.2248 11.1498 16.7582 12.0665 17.1415C13.4915 17.7498 14.8248 17.8915 15.9248 17.4332C16.3498 17.2582 16.7248 16.9915 17.0665 16.6082C17.2582 16.3998 17.4082 16.1748 17.5332 15.9082C17.6332 15.6998 17.6832 15.4832 17.6832 15.2665C17.6832 15.1332 17.6582 14.9998 17.5915 14.8498C17.5665 14.7998 17.5165 14.7082 17.3582 14.5998L14.5915 12.6332C14.4248 12.5165 14.2748 12.4332 14.1332 12.3748C13.9498 12.2998 13.8748 12.2248 13.5915 12.3998C13.4248 12.4832 13.2748 12.6082 13.1082 12.7748L12.4748 13.3998C12.1498 13.7165 11.6498 13.7915 11.2665 13.6498L11.0415 13.5498C10.6998 13.3665 10.2998 13.0832 9.85817 12.7082C9.45817 12.3665 9.02484 11.9665 8.49984 11.4498C8.0915 11.0332 7.68317 10.5915 7.25817 10.0998C6.8665 9.6415 6.58317 9.24984 6.40817 8.92484L6.30817 8.67484C6.25817 8.48317 6.2415 8.37484 6.2415 8.25817C6.2415 7.95817 6.34984 7.6915 6.55817 7.48317L7.18317 6.83317C7.34984 6.6665 7.47484 6.50817 7.55817 6.3665C7.62484 6.25817 7.64984 6.1665 7.64984 6.08317C7.64984 6.0165 7.62484 5.9165 7.58317 5.8165C7.52484 5.68317 7.43317 5.53317 7.3165 5.37484L5.38317 2.6415C5.29984 2.52484 5.19984 2.4415 5.07484 2.38317C4.9415 2.32484 4.79984 2.2915 4.65817 2.2915ZM11.6248 12.5082L11.4915 13.0748L11.7165 12.4915C11.6748 12.4832 11.6415 12.4915 11.6248 12.5082Z"
      fill="#475B78"
    />
  </svg>
);

export const LocationSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M3.01675 7.07484C4.65842 -0.141827 15.3501 -0.133494 16.9834 7.08317C17.9418 11.3165 15.3084 14.8998 13.0001 17.1165C11.3251 18.7332 8.67508 18.7332 6.99175 17.1165C4.69175 14.8998 2.05842 11.3082 3.01675 7.07484Z"
      stroke="#475B78"
      strokeWidth="1.25"
    />
    <path
      d="M7.70801 9.58333L8.95801 10.8333L12.2913 7.5"
      stroke="#475B78"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UploadDocumentSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.00033 11.3333V7.33333L4.66699 8.66666"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 7.33333L7.33333 8.66666"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6663 6.66666V9.99999C14.6663 13.3333 13.333 14.6667 9.99967 14.6667H5.99967C2.66634 14.6667 1.33301 13.3333 1.33301 9.99999V5.99999C1.33301 2.66666 2.66634 1.33333 5.99967 1.33333H9.33301"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6663 6.66666H11.9997C9.99967 6.66666 9.33301 6 9.33301 3.99999V1.33333L14.6663 6.66666Z"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BarcodeSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.34699 13H5.00033C4.58699 13 4.22033 12.9867 3.89366 12.94C2.14033 12.7467 1.66699 11.92 1.66699 9.66667V6.33333C1.66699 4.08 2.14033 3.25333 3.89366 3.06C4.22033 3.01333 4.58699 3 5.00033 3H7.30699"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0137 3H11.0003C11.4137 3 11.7803 3.01333 12.107 3.06C13.8603 3.25333 14.3337 4.08 14.3337 6.33333V9.66667C14.3337 11.92 13.8603 12.7467 12.107 12.94C11.7803 12.9867 11.4137 13 11.0003 13H10.0137"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 1.33333V14.6667"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33301 5.66667V10.3333"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SmsSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6663 6.66665V8.66665C14.6663 11.3333 13.333 12.6666 10.6663 12.6666H10.333C10.1263 12.6666 9.92634 12.7666 9.79967 12.9333L8.79967 14.2666C8.35967 14.8533 7.63967 14.8533 7.19967 14.2666L6.19967 12.9333C6.09301 12.7866 5.84634 12.6666 5.66634 12.6666H5.33301C2.66634 12.6666 1.33301 12 1.33301 8.66665V5.33331C1.33301 2.66665 2.66634 1.33331 5.33301 1.33331H9.33301"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.9997 4.66665C13.9201 4.66665 14.6663 3.92045 14.6663 2.99998C14.6663 2.07951 13.9201 1.33331 12.9997 1.33331C12.0792 1.33331 11.333 2.07951 11.333 2.99998C11.333 3.92045 12.0792 4.66665 12.9997 4.66665Z"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6646 7.3333H10.6706"
      stroke="#475B78"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99666 7.3333H8.00265"
      stroke="#475B78"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.32967 7.3333H5.33566"
      stroke="#475B78"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DollarSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.78125 9.55322C5.78125 10.4132 6.44125 11.1066 7.26125 11.1066H8.93458C9.64792 11.1066 10.2279 10.4999 10.2279 9.75322C10.2279 8.93989 9.87458 8.65322 9.34792 8.46655L6.66125 7.53322C6.13458 7.34655 5.78125 7.05989 5.78125 6.24655C5.78125 5.49989 6.36125 4.89322 7.07458 4.89322H8.74792C9.56792 4.89322 10.2279 5.58655 10.2279 6.44655"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 4V12"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99967 14.6667C11.6816 14.6667 14.6663 11.6819 14.6663 8.00001C14.6663 4.31811 11.6816 1.33334 7.99967 1.33334C4.31778 1.33334 1.33301 4.31811 1.33301 8.00001C1.33301 11.6819 4.31778 14.6667 7.99967 14.6667Z"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RoleChangeSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.667 5.33334C13.7716 5.33334 14.667 4.43791 14.667 3.33334C14.667 2.22877 13.7716 1.33334 12.667 1.33334C11.5624 1.33334 10.667 2.22877 10.667 3.33334C10.667 4.43791 11.5624 5.33334 12.667 5.33334Z"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.34634 1.46668C8.90634 1.38001 8.45967 1.33334 7.99967 1.33334C4.31967 1.33334 1.33301 4.32001 1.33301 8.00001C1.33301 11.68 4.31967 14.6667 7.99967 14.6667C11.6797 14.6667 14.6663 11.68 14.6663 8.00001C14.6663 7.54668 14.6197 7.10001 14.533 6.67334"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EmptySvg = () => (
  <svg
    width="132"
    height="84"
    viewBox="0 0 132 84"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M66 83.5625C102.451 83.5625 132 77.0986 132 69.125C132 61.1514 102.451 54.6875 66 54.6875C29.5492 54.6875 0 61.1514 0 69.125C0 77.0986 29.5492 83.5625 66 83.5625Z"
      fill="#F5F4F7"
    />
    <path
      d="M113.438 27.38L92.5114 3.65713C91.5069 2.04013 90.0405 1.0625 88.4957 1.0625H43.5043C41.9595 1.0625 40.4931 2.04012 39.4886 3.65506L18.5625 27.3821V46.4375H113.438V27.38Z"
      stroke="#73B0F7"
      stroke-width="2.0625"
    />
    <path
      d="M85.8268 33.9202C85.8268 30.6099 87.8769 27.8771 90.42 27.875H113.438V65.2826C113.438 69.6612 110.715 73.25 107.353 73.25H24.6469C21.285 73.25 18.5625 69.6592 18.5625 65.2826V27.875H41.58C44.1231 27.875 46.1732 30.6037 46.1732 33.914V33.9594C46.1732 37.2697 48.246 39.9427 50.787 39.9427H81.213C83.754 39.9427 85.8268 37.2449 85.8268 33.9346V33.9202Z"
      fill="#DCEBFD"
      stroke="#73B0F7"
      stroke-width="2.0625"
    />
  </svg>
);

export const DashboardArrowDownSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.92 8.17993H11.69H6.07999C5.11999 8.17993 4.63999 9.33993 5.31999 10.0199L10.5 15.1999C11.33 16.0299 12.68 16.0299 13.51 15.1999L15.48 13.2299L18.69 10.0199C19.36 9.33993 18.88 8.17993 17.92 8.17993Z"
      fill="#8690C9"
      fillOpacity="0.69"
    />
  </svg>
);

export const ProgressSvg = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.41421 8.41421L6.29289 10.5355C5.51184 11.3166 4.24551 11.3166 3.46447 10.5355C2.68342 9.75449 2.68342 8.48816 3.46447 7.70711L5.58579 5.58579L0 0H14V14L8.41421 8.41421Z"
      fill="#38C7C8"
      fillOpacity="0.56"
    />
  </svg>
);

export const RegressSvg = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.41421 5.58579L6.29289 3.46447C5.51184 2.68342 4.24551 2.68342 3.46447 3.46447C2.68342 4.24552 2.68342 5.51184 3.46447 6.29289L5.58579 8.41421L0 14H14V0L8.41421 5.58579Z"
      fill="#A183EA"
    />
  </svg>
);

export const DashboardUserSvg = () => (
  <svg
    width="34"
    height="28"
    viewBox="0 0 34 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3568 22.1419C12.381 22.1419 11.4384 22.177 10.503 22.1326C9.68628 22.0928 9.08565 21.4466 9.0168 20.6481C8.8197 18.3816 10.3772 16.307 12.6279 15.8247C12.9318 15.7591 13.1764 15.8107 13.4565 15.9582C15.6502 17.0962 17.8368 17.0681 20.002 15.8669C20.1135 15.8037 20.2726 15.7709 20.3985 15.792C22.813 16.2041 24.4156 18.2131 24.2612 20.6247C24.2114 21.4185 23.6107 22.0882 22.8011 22.1303C21.8563 22.1794 20.9042 22.142 19.9237 22.142C19.9166 22.0343 19.9071 21.936 19.9071 21.8376C19.9071 21.2476 19.9142 20.6575 19.9048 20.0675C19.8929 19.3486 19.4536 18.9249 18.7176 18.9225C17.3406 18.9202 15.9636 18.9225 14.5866 18.9248C13.7985 18.9271 13.3735 19.351 13.371 20.1236V21.8376C13.371 21.9289 13.3639 22.0203 13.3568 22.1443V22.142V22.1419Z"
      fill="#7C54DE"
    />
    <path
      d="M22.6255 10.362V11.8512C22.6255 12.2679 22.4213 12.4974 22.0035 12.4716C21.7067 12.4552 21.5833 12.577 21.4527 12.8181C20.42 14.717 18.7722 15.6794 16.6142 15.67C14.4442 15.6582 12.8013 14.6748 11.7899 12.7502C11.6831 12.5465 11.5668 12.4716 11.3364 12.4763C10.8331 12.488 10.6527 12.2984 10.6527 11.802V8.88226C10.6527 8.36483 10.8308 8.17517 11.346 8.19393C11.5858 8.20325 11.6879 8.10727 11.7923 7.913C12.8014 5.99772 14.4324 5.01661 16.5905 5.00027C18.7604 4.98151 20.4153 5.94858 21.4504 7.85914C21.5857 8.10737 21.7163 8.21268 22.0059 8.19864C22.4143 8.17758 22.6161 8.39302 22.6208 8.79571C22.6256 9.32016 22.6208 9.84472 22.6208 10.3692L22.6256 10.3622L22.6255 10.362ZM16.645 7.25494C14.5961 7.25494 13.4114 7.98551 12.8582 9.09529C12.6232 9.56589 12.5425 10.0975 12.5709 10.6219C12.5757 10.7179 12.5828 10.7998 12.5946 10.849C12.9602 12.4856 13.7509 13.2139 15.3724 13.5112C16.1227 13.5954 16.8943 13.5978 17.6516 13.5393C18.8411 13.448 19.8975 12.7502 20.4223 11.6942C20.8069 10.9192 20.8235 10.3736 20.7167 9.54011C20.674 9.2006 19.9332 7.18935 16.645 7.25725V7.25494Z"
      fill="#7C54DE"
    />
  </svg>
);

export const ExportFileSvg2 = () => (
  <svg
    width="24"
    height="23"
    viewBox="0 0 24 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.44 8.57275C20.04 8.86209 21.51 10.5888 21.51 14.3688V14.4901C21.51 18.6621 19.72 20.3328 15.25 20.3328H8.73998C4.26998 20.3328 2.47998 18.6621 2.47998 14.4901V14.3688C2.47998 10.6168 3.92998 8.89009 7.46998 8.58209"
      stroke="#A183EA"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 2.13281V14.1541"
      stroke="#A183EA"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.3499 12.0728L11.9999 15.1994L8.6499 12.0728"
      stroke="#A183EA"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UploadImageSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99967 1.33333C4.31967 1.33333 1.33301 4.31999 1.33301 7.99999C1.33301 11.68 4.31967 14.6667 7.99967 14.6667C11.6797 14.6667 14.6663 11.68 14.6663 7.99999"
      stroke="#475B78"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.66699 7.33334L14.1337 1.86667"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6663 4.55333V1.33333H11.4463"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DetailsPageSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.5 11.3V7.04001C20.5 3.01001 19.56 2 15.78 2H8.22C4.44 2 3.5 3.01001 3.5 7.04001V18.3C3.5 20.96 4.96001 21.59 6.73001 19.69L6.73999 19.68C7.55999 18.81 8.80999 18.88 9.51999 19.83L10.53 21.18"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.2 21.4C19.9673 21.4 21.4 19.9673 21.4 18.2C21.4 16.4327 19.9673 15 18.2 15C16.4327 15 15 16.4327 15 18.2C15 19.9673 16.4327 21.4 18.2 21.4Z"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 22L21 21"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 7H16"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 11H15"
      stroke="#475B78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowRightSvg = ({ fill }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.2002 10.4899L13.2302 8.51993L10.0202 5.30993C9.34018 4.63993 8.18018 5.11993 8.18018 6.07993V12.3099V17.9199C8.18018 18.8799 9.34018 19.3599 10.0202 18.6799L15.2002 13.4999C16.0302 12.6799 16.0302 11.3199 15.2002 10.4899Z"
      fill={fill}
    />
  </svg>
);
